export default {
    methods: {
        // validacion de formato de correo
        validateEmail(value) {
            let emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!emailPattern.test(value)) {
                return false;
            }
            return true;
        }
    }
}